<template>
    <div class="dropdown-content" ref="listaNotificaciones">
        <div v-if="loading && showLoading" class="dropdown-item is-loading"></div>
        <div v-if="!loading">
            <transition-group name="bounce">
                <div v-for="notification in notifications" :key="notification.id">
                    <div class="dropdown-item">
                        <router-link class="" :to="notificationUrl(notification)" @click.native="clickItem">
                            <p v-html="notificationTxt(notification)"></p>
                            <p class="time">{{ formatFecha(new Date(notification.created_at)) }}</p>
                        </router-link>
                        <button v-if="canDelete(notification)" class="delete is-small" @click.prevent="deleteNotification(notification)"></button>
                    </div>
                    <hr class="dropdown-divider">
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        props:{
            showLoading:{
                type: Boolean,
                default: false
            },
            visible: {
                type: Boolean,
                default: true
            }
        },
        name: 'ListaNotificaciones',
        data() {
            return {
                loading: true
            }
        },
        computed: {
			...mapState('notification',['notifications']),
			...mapState('user',['user'])
        },
        created(){
            //Traer notifications del api
            this.$store.dispatch('notification/fetchNotifications')
            .then(() => {
                this.loading = false

                this.markAsRead()

            })
        },
        updated() {
            this.$refs.listaNotificaciones.scrollTop = 0
        },
        methods: {
            notificationTxt(notification){
				let msg, data, desicion

				if (notification.data == undefined) {
					data = notification
				}else{
					data = notification.data
				}

				switch(notification.type){
					case 'App\\Notifications\\NuevoSeguidor':
						msg = "El usuario <strong>" + data.usuario.name + '</strong> ha comenzado a seguirte'
					break;

					case 'App\\Notifications\\UsuarioSeUneQuiniela':
						if (data.usuario.id == this.user.user.id) {
							msg = "Te has unido a la quiniela <strong>"+ data.quiniela.nombre +"</strong>"
						}else{
							msg = "El usuario <strong>"+ data.usuario.name +"</strong> se ha unido a tu quiniela <strong>"+ data.quiniela.nombre +"</strong>"
						}
					break;

					case 'App\\Notifications\\QuinielaTerminada':
						msg = "Tu quiniela <strong>"+ data.quiniela.nombre +"</strong> ha terminado"
					break;

					case 'App\\Notifications\\QuinielaGanada':
						msg = "Haz ganado la quiniela <strong>"+data.quiniela.nombre+"</strong> con "+data.premio+" puntos"

					break;

					case 'App\\Notifications\\QuinielaEnJuego':
						msg = "La quiniela <strong>"+data.quiniela.nombre+"</strong> esta ahora en juego, mucha suerte"
					break;

					case 'App\\Notifications\\RecibePuntos':
						msg = ((data.usuario != undefined) ? data.usuario.name:'Quinielazo') + ' te ha enviado <strong>' + data.puntos + '</strong> puntos'
					break;

					case 'App\\Notifications\\SolicitudDeUnion':
						msg = 'El usuario ' + data.usuario.name + ' se quiere unir a tu quiniela privada <strong>' + data.quiniela.nombre +'</strong>'
					break;

					case 'App\\Notifications\\RespuestaASolicitud':
						desicion = (data.solicitud.status == 1) ? 'rechazada' : 'aceptada'
						msg = 'Tu solicitud para unirte a la quiniela ' + data.quiniela.nombre + ' fue ' + desicion + ' por el dueño de la quiniela'
					break;
				}

				return msg
			},
			notificationUrl(notification){
				let url, data

				if (notification.data == undefined) {
					data = notification
				}else{
					data = notification.data
				}

				switch(notification.type){
					case 'App\\Notifications\\NuevoSeguidor':
						url = '/perfil/' + data.usuario.id
					break;
					case 'App\\Notifications\\UsuarioSeUneQuiniela':
					case 'App\\Notifications\\QuinielaTerminada':
					case 'App\\Notifications\\QuinielaGanada':
					case 'App\\Notifications\\QuinielaEnJuego':
					case 'App\\Notifications\\RespuestaASolicitud':
					case 'App\\Notifications\\SolicitudDeUnion':
						url = '/ver-quiniela/' + data.quiniela.id
					break;
					default:
						url = '/jugar'
					break;
				}

				return url
			},
			markAsRead(){
				//Marcar todas las notificaciones no leidas como leidas
				let unreadIds = this.notifications.filter(notification => notification.read_at == null)
				.map(n => { return n.id})

				if (unreadIds.length > 0) {
					this.$store.dispatch('notification/markAsRead', { notifications: unreadIds })
				}
			},
			deleteNotification(notification){
				this.$store.dispatch('notification/delete',notification)
			},
			formatFecha(fecha){
				return this.$timeago.format(fecha,'es')
			},
			canDelete(notification){
				let resp = true;
				switch(notification.type){
					case 'App\\Notifications\\RecibePuntos':
						resp = false
					break;
				}

				return resp
            },
            clickItem(){
                this.$emit('clickItem')
            }
        },
        watch: {
            visible(newValue){
                if(newValue == true){
                    this.$refs.listaNotificaciones.scrollTop = 0
                    this.markAsRead()
                }
            }
        }
    }
</script>

<style lang="css" scoped>
.is-loading::after, .control.is-loading::after, .loader, .select.is-loading::after {
    -webkit-animation: spinAround .5s infinite linear;
    animation: spinAround .5s infinite linear;
    border: 2px solid #dbdbdb;
    border-radius: 290486px;
    border-right-color: transparent;
    border-top-color: transparent;
    content: "";
    display: block;
    height: 1em;
    position: relative;
    width: 1em;
}
</style>